module.exports = __webpack_public_path__ + "img/chunhakrai.6c5e26f1.jpeg";